import { Button } from '@mantine/core';
import { Download } from 'lucide-react';

import styles from './index.css';

const PLUGIN_DOWNLOAD_URL = 'https://presspass-plugin.s3.us-east-1.amazonaws.com/presspass-site-editor.zip';

const CALENDLY_URL = 'https://calendly.com/spm-presspass/30min';

const STEPS = [
  {
    description: 'Grab the latest version of the PressPass Site Editor plugin as a zip file.',
    number: '1',
    showDownloadButton: true,
    title: 'Download the plugin',
  },
  {
    description:
      'In WP admin → Plugins → Add Plugin (top right) → Upload Plugin → choose the zip → Click Install Now → Activate Plugin.',
    number: '2',
    showDownloadButton: false,
    title: 'Install on your WordPress site',
  },
  {
    description:
      'After activation, a Getting Started page pops up in WP admin. Enter your publication title and timezone, and you are ready to start using the AI Site Editor.',
    number: '3',
    showDownloadButton: false,
    title: "Fill out two fields and you're connected",
  },
];

export default function InstallPage() {
  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <div className={styles.headerInner}>
          <a href="/" className={styles.brand}>
            <span className={styles.brandMark}>
              <svg viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
                <rect width="100%" height="100%" rx="80" ry="80" fill="hsl(200, 81%, 42%)" />
                <text
                  x="52%"
                  y="58%"
                  textAnchor="middle"
                  dominantBaseline="middle"
                  fontFamily="serif"
                  fontWeight="bold"
                  fontSize="380"
                  fill="#fff"
                >
                  P
                </text>
              </svg>
            </span>
            <span className={styles.brandName}>PressPass</span>
          </a>
          <nav className={styles.headerNav}>
            <Button
              component="a"
              href={CALENDLY_URL}
              target="_blank"
              rel="noopener noreferrer"
              radius="md"
              size="sm"
              className={styles.demoButton}
            >
              Book a demo
            </Button>
          </nav>
        </div>
      </header>

      <main>
        <section className={styles.hero}>
          <div className={styles.container}>
            <h1 className={styles.heroHeading}>Install the AI Site Editor</h1>
            <p className={styles.heroSubheading}>Installation takes 5 minutes — no developer required.</p>
          </div>
        </section>

        <section className={styles.stepsSection}>
          <div className={styles.container}>
            <div className={styles.stepsGrid}>
              {STEPS.map((step) => (
                <div key={step.number} className={styles.stepCard}>
                  <div className={styles.stepNumber}>{step.number}</div>
                  <h3 className={styles.stepTitle}>{step.title}</h3>
                  <p className={styles.stepDescription}>{step.description}</p>
                  {step.showDownloadButton && (
                    <Button
                      component="a"
                      href={PLUGIN_DOWNLOAD_URL}
                      download
                      leftSection={<Download size={18} />}
                      classNames={{
                        root: styles.stepButton,
                      }}
                    >
                      Download now
                    </Button>
                  )}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
